// filepath: c:\Users\makar\projects\report-notes\src\pages\reports\previewPage\previewTheme.js
import {createTheme} from '@mui/material/styles';

// A serif-first, print-like typography for previewing reports
const previewTheme = createTheme({
    typography: {
        fontFamily: "'Georgia', 'Times New Roman', Times, serif",
        fontSize: 16, // base size a bit larger for readability
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 600,
        // NodeRenderer maps heading levels to h4/h5/h6
        h4: {
            fontSize: '2rem',
            fontWeight: 700,
            lineHeight: 1.25,
            letterSpacing: 0,
            marginTop: '2rem',
            marginBottom: '0.75rem',
            color: "#17365d",
        },
        h5: {
            fontSize: '1.75rem',
            fontWeight: 700,
            lineHeight: 1.3,
            letterSpacing: 0,
            marginTop: '1.5rem',
            marginBottom: '0.5rem',
            color: "#365f91",
        },
        h6: {
            fontSize: '1.125rem',
            fontWeight: 700,
            lineHeight: 1.35,
            letterSpacing: 0,
            marginTop: '1.5rem',
            marginBottom: '0.5rem',
            textTransform: 'none',
            color: "#365f91",
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.75,
        },
        body2: {
            fontSize: '0.9375rem',
            lineHeight: 1.65,
        },
        caption: {
            fontSize: '0.8125rem',
            lineHeight: 1.6,
        },
    },
    components: {
        MuiTypography: {
            styleOverrides: {
                paragraph: {
                    marginBlockStart: '0.75rem',
                    marginBlockEnd: '0.75rem',
                },
                root: {
                    // nicer hyphenation and kerning for long-form text
                    textRendering: 'optimizeLegibility',
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                // Scope with a class applied on the page container
                '.preview-root': {
                    'ol, ul': {
                        paddingInlineStart: '1.5rem',
                        marginBlock: '0.75rem',
                    },
                    'li': {
                        marginBlockEnd: '0.375rem',
                        lineHeight: 1.6,
                    },
                    '.inline-ref sup': {
                        fontSize: '0.75em',
                        verticalAlign: 'super',
                    },

                    // Table-specific adjustments: remove bottom margins inside table cells
                    'table': {
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBlock: '0.75rem',
                    },
                    // Reset bottom margins for headings, paragraphs, lists that appear inside tables
                    'table p, table h4, table h5, table h6, table ol, table ul': {
                        marginBlockStart: 0,
                        marginBlockEnd: 0,
                    },
                    // Slightly smaller list indent inside tables and no extra spacing between items
                    'table ol, table ul': {
                        paddingInlineStart: '1.25rem',
                    },
                    'table li': {
                        marginBlockEnd: 0,
                        lineHeight: 1.4,
                    },
                    // Table header styling
                    'table th': {
                        backgroundColor: '#f5f7fa',
                        fontWeight: 700,
                        padding: '10px 12px',
                        borderBottom: '2px solid rgba(0,0,0,0.12)',
                        textAlign: 'left',
                        color: '#17365d',
                    },
                    'table td, table th': {
                        verticalAlign: 'top',
                        padding: '8px',
                    },
                },
            },
        },
        // Prevent uppercase labels on Buttons and Tabs in preview as well
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
    },
});

export default previewTheme;
